import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import { useRxLabelState } from '@Hooks/useRxLabelState';

function Input({ id, name, label, value, error, errorMessages, onChange, type, afterLabelContent, onBlur, isSubmitted = false }) {
  const [dirty, setDirty] = useState(false);
  const { labelActive, labelRef, handleFocusChange, handleValueChange } = useRxLabelState();

  const handleChange = (event) => {
    if (!dirty) {
      setDirty(true);
    }
    handleValueChange(event);
    onChange(event);
  };

  const handleBlur = (event) => {
    handleFocusChange(event);
    onBlur(event);
  };

  const resolveError = () => (
    <div className={cn('els-text-input-label-error', (!errorMessages || !dirty) && !isSubmitted && 'u-els-hide-visually')}>
      {errorMessages.map((item) => (
        <div key={item}>{item}</div>
      ))}
    </div>
  );

  return (
    <div className="edit-field clearfix">
      <div
        className={cn(
          'els-text-input clear',
          !!error && dirty && 'els-text-input-error',
          !!errorMessages && (dirty || isSubmitted) && 'els-text-input-error'
        )}>
        <label ref={labelRef} htmlFor={id} className={cn('els-text-input-label', { active: labelActive || (value && value.length) })}>
          {label}
        </label>
        <input
          id={id}
          className="els-text-input-field"
          name={name}
          value={value}
          onChange={handleChange}
          autoComplete="off"
          onFocus={handleFocusChange}
          onBlur={handleBlur}
          type={type}
        />
        {afterLabelContent}
        <span className={cn('els-text-input-label-error', (!error || !dirty) && 'u-els-hide-visually')}>Please enter a valid value</span>
        {errorMessages && resolveError()}
      </div>
    </div>
  );
}

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
  afterLabelContent: PropTypes.node,
  isSubmitted: PropTypes.bool,
};

Input.defaultProps = {
  error: false,
  onChange: noop,
  onBlur: noop,
};

export default Input;
